import { FETCH_SINGLE_USER_REQUEST } from "../types/GetUser";

export const fetchSingleUserRequest = (userId, token) => ({
    type: FETCH_SINGLE_USER_REQUEST,
    payload: { userId, token },
  });
  